window.$(function () {
  const EXPIRES_IN_ONE_DAY = 1;
  const awarenessBar = window.$('.ti-awareness-bar');

  window.$('.awareness-bar-close').on('click', function () {
    awarenessBar.slideUp();
    // Server will look for this cookie; if set, it won't instantiate an awareness bar
    window.Cookies.set('awareness-bar-closed', true, { expires: EXPIRES_IN_ONE_DAY });
  });
});
